import { render, staticRenderFns } from "./calificacionDrivers.vue?vue&type=template&id=87287630&scoped=true"
import script from "./calificacionDrivers.vue?vue&type=script&lang=js"
export * from "./calificacionDrivers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87287630",
  null
  
)

export default component.exports